import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import { Figure, Menu, Frame, Action } from '@studiometa/ui';
import { isDev } from './config.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Menu: Menu[],
 *     Frame: Frame[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Action,
      Figure,
      Menu,
      Frame,
      Tabs: () => importWhenVisible(() => import('./components/Tabs.js'), 'Tabs'),
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
    },
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll.
   */
  scrolled({ y }) {
    toggleClass(document.documentElement, 'is-on-top', y <= 0);
  }
}

export default createApp(App);
